import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import piniaPluginPersistedState from "pinia-plugin-persistedstate"
import { loadFonts } from './plugins/webfontloader'

loadFonts()
const pinia = createPinia()
pinia.use(piniaPluginPersistedState)

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(pinia)
  .mount('#app')
